export default "__VITE_ASSET__f3a67a1b__"